import { type HttpBadStatusCodeError, type UnknownError } from '@cian/peperrors/shared';

import { EQueryKeys } from '@/packages/query-state/shared/store/EQueryKeys';

export type QueryError = UnknownError | HttpBadStatusCodeError;

export type QueryKey = [EQueryKeys.SearchOffers__V2_GetInfiniteSearchResultDesktop];

export const getQueryKey = (): QueryKey => [EQueryKeys.SearchOffers__V2_GetInfiniteSearchResultDesktop];
